<template>
  <div class="buttongroup hide-for-print">
    <div
      class="btn"
      @click="select()"
      v-for="(val, key) in values"
      v-bind:class="{ isActive: isActive(key) }"
      v-html="val"
      ></div>
  </div>
</template>

<script>
// import _ from 'lodash'
// import {EventBus} from '@/event-bus.js'

export default {
  name: 'buttongroup',
  props: {
    values: {
      type: Object,
      required: true
    },
    selectedKey: {
      required: true
    }
  },
  methods: {
    select () {
      this.$emit('click')
    },
    isActive (key) {
      return this.selectedKey === key
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/components/btns';

  .buttongroup{
    display: flex; -js-display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/ButtonGroup.vue